export { default } from "./ShoppingCartData";
